const ToggleHook = {
  mounted() {
    this.open = false;

    this.el.addEventListener('click', () => {
      if (this.open) {
        liveSocket.execJS(this.el, this.el.dataset.close);
      } else {
        liveSocket.execJS(this.el, this.el.dataset.open);
      }
      this.open = !this.open;
    });
  },
};

export default ToggleHook;
